import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal, getUsersByClinicId, navigateTo, openModal, removeClinic, saveHistory, setSelectedClinic } from '../../redux/actions';
import { patientListBaseStyles } from '../../theme/style';
import { statusTypes } from '../../utils/CFuncs';
import { clinicTableFields, modalNames, urls } from '../../utils/Objects';
import { Items, Storage } from '../../utils/StorageHelper';
import EntityTable from '../common/EntityTable';
import RemoveClinicModal from './RemoveClinicModal';
import { Loading } from '../common';

class ClinicList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinics: [],
    };

    // this.sortByName = this.updateSort.bind(this, "name");
    // this.sortByLocation = this.updateSort.bind(this, "location");
    this.updateList = this.updateList.bind(this);
  }
  async componentDidMount() {
    const newClinicList = await this.getAllDatas();
    this.setState({ clinics: newClinicList });
  }
  async componentDidUpdate(prevProps) {
    console.log('componentDidUpdate');
    console.log(this.props.list);
    if (JSON.stringify(this.props.list) !== JSON.stringify(prevProps.list)) {
      const newClinicList = await this.getAllDatas();
      this.setState({ clinics: newClinicList });
    }
  }

  filterByStatus = (items) => {
    if (this.props.status == -1) return items;
    return items.filter((item) => item.status == this.props.status);
  };
  updateList(list) {
    this.setState({ clinics: list });
  }

  getAllDatas = async () => {
    const promises = this.props.list.map(async (clinic) => {
      const statusName = statusTypes[clinic.status];

      const { name, location, email } = clinic;
      return {
        id: clinic.id,
        image: {
          picture: clinic.picture,
          id: clinic.id,
        },
        name,
        location,
        email,
        status: {
          statusName,
          pathname: urls.clinics,
          onClick: null,
        },
        details: {
          pathname: urls.clinicDetails,
          state: { clinicId: clinic.id },
          onClick: () => {
            Storage.set(Items.clinicId, clinic.id);
            this.props.setSelectedClinic(clinic);
          },
        },
        users: {
          value: 'users',
          pathname: urls.clinicUsers,
          state: { ...clinic },
          onClick: () => {
            console.log(clinic, this.props.setSelectedClinic);
            Storage.set(Items.clinicId, clinic.id);
            this.props.getUsersByClinicId(clinic.id);
            this.props.setSelectedClinic(clinic);
          },
        },
        patients: {
          value: 'patients',
          pathname: urls.clinicPatients,
          onClick: () => {
            console.log(clinic, this.props.setSelectedClinic);
            this.props.setSelectedClinic(clinic);
            Storage.set(Items.clinicId, clinic.id);
          },
        },
        remove: {
          pathname: urls.clinics,
          onClick: () => {
            this.props.openModal(modalNames.removeClinic);
            this.props.setSelectedClinic(clinic);
          },
          value: 'remove clinic',
        },
      };
    });
    const newList = await Promise.all(promises);
    console.log({ newList });
    return newList;
  };

  render() {
    console.log(this.props.list);
    const clinics = this.props.list;

    if (this.state.clinics[0] == -1) {
      return (
        <div style={patientListBaseStyles.container}>
          <h1 style={patientListBaseStyles.headerTitle}>clinics</h1>
          <p>Loading appointments..</p>
          <CircularProgress size={100} thickness={7} />
        </div>
      );
    }
    if (clinics.length == 0) {
      return (
        <div style={patientListBaseStyles.container}>
          <div style={patientListBaseStyles.headerText}>
            <h1 style={patientListBaseStyles.headerTitle}>clinics</h1>
            <p style={patientListBaseStyles.subHeaderText}>No clinics have currently reported any radicular pain.</p>
          </div>
        </div>
      );
    }
    // Sorts and truncates the appointment list

    return (
      <div>
        <RemoveClinicModal
          title="remove clinic"
          closeModal={this.props.closeModal}
          showModal={this.props.modal.modalName === modalNames.removeClinic}
        />
        {this.props.isLoading && <Loading />}

        <EntityTable entities={this.state.clinics} tableFields={clinicTableFields} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    list: state.clinic.clinicList,
    isLoading:state.message.isLoading

  };
};
const mapDispatchToProps = {
  saveHistory,
  navigateTo,
  setSelectedClinic,
  openModal,
  getUsersByClinicId,
  closeModal,
  removeClinic,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClinicList);
